import { CompositorImageApi } from "../api/3d/CompositorImageApi/CompositorImageApi";
import { ICompositorImageData } from "../api/3d/CompositorImageApi/type";

export class CompositorImageService {
  private compositorImageApi: CompositorImageApi = new CompositorImageApi();

  public async getCompositorImage(
    data: ICompositorImageData
  ): Promise<string | null> {
    const response = await this.compositorImageApi.getCompositorImage(data);
    const blobFile = response.data;

    const textFile = await blobFile.text();
    if (textFile.includes("message")) {
      return null;
    }

    return URL.createObjectURL(blobFile);
  }
}
